module.exports = __webpack_public_path__ + "static/pm1.c234cd3c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/pm/pm1.png
// module id = 530
// module chunks = 35783957827783